/** @jsx jsx */
import { jsx, Box, Flex } from 'theme-ui';
import React, { FunctionComponent } from 'react';

// Components
import Dropdown, { DropdownOption } from '../dropdown';

// Icons
import SearchSVG from '../../../static/assets/icons/outlined/action/main/search.svg';

// Hooks
import useFilter from '../../hooks/useFilter';

// Styles
import * as style from './style';

interface FilterProps {
  topicsOptions?: DropdownOption[];
  filterByOptions?: DropdownOption[];
  className?: string;
}

const Filter: FunctionComponent<FilterProps> = React.memo(
  ({ topicsOptions, filterByOptions, className }) => {
    const { topic, filterBy, search } = useFilter();

    return (
      <Flex sx={style.FilterContainer} className={className}>
        {topicsOptions && (
          <Box>
            <Dropdown
              label="Resource"
              options={topicsOptions}
              disabled={topicsOptions.length === 0}
              onSelect={(e, o) => topic.set(o.value || o.label)}
              defaultValue={topic.current}
            />
          </Box>
        )}
        {filterByOptions && (
          <Box>
            <Dropdown
              label="Filter by"
              options={filterByOptions}
              disabled={filterByOptions.length === 0}
              onSelect={(e, o) => filterBy.set(o.value || o.label)}
              defaultValue={filterBy.current}
            />
          </Box>
        )}
        <Box sx={style.SearchBox}>
          <input
            id="search"
            type="text"
            sx={style.SearchInput}
            placeholder="Search"
            defaultValue={search.current || ''}
            onChange={e => search.set(e.target.value)}
          />
          <label htmlFor="search" sx={style.SearchIcon}>
            <SearchSVG />
          </label>
        </Box>
      </Flex>
    );
  },
);

export default Filter;
